type UserDialogEntry = {id: number; priority: number};

let nextUserDialogId = 1;
const userDialogEntries = new Map<number, UserDialogEntry>();
const userDialogListeners = new Set<() => void>();

function emitUserDialogOwners() {
    userDialogListeners.forEach((listener) => listener());
}

export function registerUserDialog(priority: number) {
    const id = nextUserDialogId++;
    userDialogEntries.set(id, {id, priority});
    return id;
}

export function publishUserDialogOwners() {
    emitUserDialogOwners();
}

export function unregisterUserDialog(id: number) {
    if (!userDialogEntries.delete(id)) {
        return;
    }
    emitUserDialogOwners();
}

export function subscribeUserDialogOwner(listener: () => void) {
    userDialogListeners.add(listener);
    return () => {
        userDialogListeners.delete(listener);
    };
}

export function getActiveUserDialogId() {
    const selected = {entry: null as UserDialogEntry | null};
    userDialogEntries.forEach((entry) => {
        const current = selected.entry;
        if (!current || entry.priority > current.priority || (entry.priority === current.priority && entry.id > current.id)) {
            selected.entry = entry;
        }
    });
    return selected.entry ? selected.entry.id : null;
}
